import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Link } from 'react-router-dom';
import RSVP_OPEN from '../config/rsvp';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      if (window.innerWidth > 900) { setHidden(false); return; }

      const y = window.scrollY;
      if (y > lastScrollY.current && y > 50) {
        setHidden(true);
        setMobileOpen(false);
      } else if (y < lastScrollY.current) {
        setHidden(false);
      }
      lastScrollY.current = y;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { to: '/',           label: 'Home' },
    ...(RSVP_OPEN ? [{ to: '/rsvp', label: 'RSVP' }] : []),
    { to: '/schedule',   label: 'Schedule' },
    { to: '/travel',     label: 'Travel & Stay' },
    { to: '/things',     label: 'Things to Do' },
    { to: '/registry',   label: 'Registry' },
    { to: '/faq',        label: 'FAQ' },
    { to: '/beach-cam',  label: 'Live Beach Cam' },
  ];

  return (
    <>
      <nav className={`navbar solid${hidden ? ' navbar--hidden' : ''}`}>
        <div className="navbar-inner">
          <Link to="/" className="navbar-logo">
            <img src="/ferrys-logo-gator.png" alt="The Ferrys" className="navbar-logo-img" />
          </Link>

          <ul className="navbar-links">
            {links.map(({ to, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  end={to === '/'}
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          {RSVP_OPEN && <Link to="/rsvp" className="navbar-cta">RSVP</Link>}

          <button
            className="navbar-hamburger"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle navigation"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      <div className={`navbar-mobile ${mobileOpen && !hidden ? 'open' : ''}`}>
        {links.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            onClick={() => setMobileOpen(false)}
          >
            {label}
          </NavLink>
        ))}
      </div>
    </>
  );
}
